import React from 'react';
import PopUp from '../../../../../muiComponents/PopUp';
import useTranslate from '../../../../../customHooks/useTranslate';

interface UnsavedServicesChangesPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => Promise<void>;
}

const UnsavedServicesChangesPopUp = ({
    isOpen,
    onClose,
    onSave,
}: UnsavedServicesChangesPopUpProps) => {
    const translate = useTranslate();

    return (
        <PopUp
            open={isOpen}
            onCancel={() => onClose()}
            onSave={async () => {
                await onSave();
                onClose();
            }}
            cancelText={translate('discard_changes')}
            saveText={translate('save_and_continue')}
        >
            {translate('unsaved_changes_warning')}
        </PopUp>
    );
};

export default UnsavedServicesChangesPopUp;
